import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

import report from './modules/report.js';
import taskmaster from './modules/taskmaster.js';
import weather from './modules/weather.js';
import messages from './modules/messages.js';
import proximity from './modules/proximity.js';

import actions from './actions.js';

import config from './../../config/config.js'

export default new Vuex.Store({
	modules: {
		report,
		taskmaster,
		weather,
		messages,
		proximity
	},
	state: {
		debug: false,
		floor_level: '0',
		base_layer: 'map',
		map: {map: null, layers: [], drawLayer: null, assetsLayer: null, center: null, zoom: null, pathLayer: null, overlayLayer: null, traceLayer: null},
		game: null,
		zones: {}, //Object.assign({}, JSON.parse(localStorage.getItem('zones'))),
		floors: {},
		paths: {},
		features: {},
		path_features: {},
		roads_vector: {},
		stairs_vector: {},
		workers: {},
		sprites: {},
		companies: [],
		schedule: {},
		filteredWorkers: [],
		vehicle_types: {},
		vehicles: {},
		vehicle_sprites: {},
		speed: 1,
		time: 0,
		day: 1,
		clock: '',
		workers_config: config.workers,
		watcher: {},
		move_watcher: {},
		position: {},
		worker_status: {},
		alert: {},
		time_to: null,
		muster: false,
		log: {},
		bottom_menu_collapsed: false,
		styles: {},
		paused: true,
		load: false,
		save: false,
		location: null,
		save_file: null,
		logged: false,
		user: {},
		view: null,
		side_panel: 'main',
		havoc: false,
		exit_dialog: false,
		side_panel_open: true,
		start_date: null,
		assets_loaded: false,
		error: false,
		flash: {},
		lock: {},
		events: {},
		show_help: false,
		show_message: false,
		selected_workers: []
	},
	mutations: {
		setState(state, [name, data]) {
			name = name.split('.');
			if (name[1] !== undefined ) {
				state[name[0]][name[1]] = data;
			}
			else state[name] = data;
		},
		set_map(state, object) {
			for (let i in object) {
				state.map[i] = object[i];
			}
		},
		set_filteredWorkers (state, searchName) {
			const {workers} = state;
			const regExp = new RegExp(searchName.split(' ').join('|'), 'i');

			Object.filter = (obj, predicate) =>
				Object.keys(obj)
				.filter( key => predicate(obj[key]) )
				.reduce( (res, key) => (res[key] = obj[key], res), {} );


			//Object.filter(workers, item => ((item.first_name.search(regExp) > -1 || item.last_name.search(regExp) > -1)));

			state.filteredWorkers = Object.filter(workers, item => (
				item.badge_number.toString().search(regExp) > -1 || 
				item.first_name.search(regExp) > -1 || 
				item.last_name.search(regExp) > -1 || 
				(item.first_name + ' ' + item.last_name).search(regExp) > -1 || 
				(config.worker_types[item.type].label +' - ' + (item.is_apprentice ? 'Apprentice' : config.job_types[item.job].label)).search(regExp) > -1
			));
		},
		increment_time(state) {
			state.time++
		},
		set_clock(state, value) {
			state.clock = value;
		},
		add_alert(state, object) {
			let alert = $.extend(true, {}, state.alert);
			alert[object.id] = object;

			state.alert = alert;
		},
		clear_alert(state, object) {

			let alert = $.extend(true, {}, state.alert);
			alert[object.key].status = 'resolved';
			alert[object.key].result = object;

			state.alert = alert;
			state.watcher[alert[object.key].day][state.alert[object.key].worker_id].reported = false;
			state.workers[state.alert[object.key].worker_id].alert = false;

			//delete this.state.alert[id]
		},
		alert_resolution(state, resolution) {

			let alert = $.extend(true, {}, state.alert);
			alert[resolution.key].resolution = resolution;

			state.alert = alert;
		},
		exit_alert(state, object) {

			let alert = $.extend(true, {}, state.alert);
			alert[object.key].status = 'resolved';
			alert[object.key].exit = object;

			state.alert = alert;

			//delete this.state.alert[id]
		},
		set_speed(state, value) {
			state.speed = value;
			if (state.time_to !== null) clearInterval(state.time_to);
			state.time_to = null;
			this.dispatch('start_time');
		},
		set_style(state, object) {
			state.style[object.id] = object;
		},
		add_log(state, object) {
			state.log[object.id] = object
		},
		set_time(state, value) {
			state.time = value;
		},
		set_day(state, value) {
			state.day = value;
		},
		bottom_menu_toggle(state){
			state.bottom_menu_collapsed = !state.bottom_menu_collapsed
		}
	},
	actions
})
